// ---------------------------------------------- modules import
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import {
  getFirebase,
  ReactReduxFirebaseProvider,
  ReactReduxFirebaseProviderProps
} from "react-redux-firebase";
import { applyMiddleware, createStore } from "redux";
import { createFirestoreInstance, getFirestore } from "redux-firestore";
import thunk from "redux-thunk";

import App from "./App";

import firebase, { rrfConfig } from "./config/fbInit";
import rootReducer from "./store/rootReducer";

// ---------------------------------------------- styles import
import "./index.css";
import "materialize-css/dist/css/materialize.min.css";

import * as serviceWorker from "./serviceWorker";

// ---------------------------------------------- create redux store
export interface IThunkExtraArgument {
  getFirebase: typeof getFirebase;
  getFirestore: typeof getFirestore;
}

const store = createStore(
  rootReducer,
  applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore }))
);

const rrfProps: ReactReduxFirebaseProviderProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance
};

// ---------------------------------------------- app render
ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <App />
    </ReactReduxFirebaseProvider>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.register();
